export const EVENT_STATUS_LIVE = 1;
export const EVENT_STATUS_SCHEDULED = 2;
export const EVENT_STATUS_AVAILABLE = 3;
